<!--  -->
<template>
   <div class='popup-box'>
    <div class='' v-if="type == 1">
        <div class="font_bold font_lg">一、用户须知</div>
		<span class="font_bold font_base">1、</span>高考早知道及其涉及到的产品、相关软件的所有权和运作权归早知道（福建）大数据有限公司（以下简称早知道大数据科技）所有，早知道大数据科技享有对高考早知道在线上一切活动的监督、提示、检查、纠正及处罚等权利。用户在注册程序过程中点击'同意'按钮完成注册，即表示用户与早知道大数据科技已达成协议，自愿接受本服务条款的所有内容。如果您不同意接受本协议的全部或部分条件和条款，请您不要通过网页、App应用程序、小程序或任何其他载体访问或使用《高考早知道》。<br/>
		<span class="font_bold font_base">2、</span>《高考早知道》提供高考志愿填报信息服务，旨在提供信息供用户填报志愿时参考，未满18周岁的限制民事行为能力人使用《高考早知道》的服务将被视作与其年龄、智力相适应的民事活动，若对此不确定请停止使用《高考早知道》的服务。<br/>
		<span class="font_bold font_base">3、</span>在您签署本协议之后，本协议可能因国家政策、产品以及履行本协议的环境发生变化，或《高考早知道》业务经营的发展及相关政策的变更而多次进行修改。用户应经常留意上述提示并阅读修改的内容。修改后的协议发布在本网站上即为生效，若您对修改后的协议有异议的，请立即停止登录账户及停止使用《高考早知道》产品和服务，若您登录或继续使用，将视为对修改后的协议予以认可。<br/>
		
		<span class="font_bold font_lg">二、用户服务条款</span><br/>
		<span class="font_bold font_base">1、</span>您在登录账户及使用《高考早知道》产品和服务时，于任一通道注册并接受本协议的具有同等效力。<br/>
		<span class="font_bold font_base">2、</span>《高考早知道》帐号及其中含有的、输入的或生成的全部数据、信息、上传内容的所有权及知识产权均属于早知道大数据科技所有。用户注册的账号仅限于注册用户本人使用，禁止赠与、借用、租用、转让或售卖。<br/>
		<span class="font_bold font_base">3、</span>用户应保证注册《高考早知道》帐号时填写的信息是真实有效的，任何非法、不真实、不准确的用户信息所产生的责任由用户自行承担。因注册信息不真实而引起的相关问题及后果，《高考早知道》不承担任何责任。<br/>
		<span class="font_bold font_base">4、</span>《高考早知道》产品及服务包括网站、网页应用、软件以及内涵的文字、图片、色彩、图表、视频、音频、版面设计和编排、数据或数据分析结论等，所有这些内容受版权、商标权、和其它知识产权及所有权法律的保护。本协议的签署不代表任何上述知识产权的授权，亦不包含上述权利的转让。用户只能在《高考早知道》授权下才能使用这些内容，而不能擅自复制、修改、编撰这些内容、或创造与内容有关的衍生产品。<br/>
		<span class="font_bold font_base">5、</span>因为用户填写的信息将会对《高考早知道》产品和服务的计算和分析结果带来一定影响，用户应承诺提供信息和数据的真实性，并符合及时、详尽、真实、准确的要求。<br/>
		<span class="font_bold font_base">6、</span>《高考早知道》可能修改、暂停或终止任何产品和服务，或会通过收费或其他有偿方式设置使用权限，亦可能会单方自行定价或自行更改或修改价格。在法律允许的范围内，这些更改在《高考早知道》进行公告后生效。<br/>
		<span class="font_bold font_base">7、</span>用户的账户或行为如有可能违反了本协议或法律，《高考早知道》将保留限制、暂停或终止你帐户的权利。<br/>
		
		<span class="font_bold font_lg">三、用户使用规则</span><br/>
		<span class="font_bold font_base" style="margin:0 0 15rpx 26rpx;">特别提示用户，使用互联网必须遵守国家有关的政策和法律，包括刑法、国家安全法、保密法、计算机信息系统安全保护条例等，保护国家利益，保护国家安全，对于违法使用互联网络而引起的一切责任，由用户负全部责任。</span><br/>
		<span class="font_bold font_base">1、</span>用户不得使用《高考早知道》发送或传播敏感信息和违反国家法律制度的信息，包括但不限于下列信息：<br/>
		<span class="font_bold font_md">(a)反对宪法所确定的基本原则的；</span><br/>
		<span class="font_bold font_md">(b)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span><br/>
		<span class="font_bold font_md">(c)损害国家荣誉和利益的；</span><br/>
		<span class="font_bold font_md">(d)煽动民族仇恨、民族歧视，破坏民族团结的；</span><br/>
		<span class="font_bold font_md">(e)破坏国家宗教政策，宣扬邪教和封建迷信的；</span><br/>
		<span class="font_bold font_md">(f)散布谣言，扰乱社会秩序，破坏社会稳定的；</span><br/>
		<span class="font_bold font_md">(g)散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span><br/>
		<span class="font_bold font_md">(h)侮辱或者诽谤他人，侵害他人合法权益的；</span><br/>
		<span class="font_bold font_md">(i)含有法律、行政法规禁止的其他内容的；</span><br/>
		<span class="font_bold font_base">2、</span>用户在使用《高考早知道》服务过程中，必须遵循以下原则：<br/>
		<span class="font_bold font_md">(a)遵守中国有关的法律和法规；</span><br/>
		<span class="font_bold font_md">(b)不得为任何非法目的而使用网络服务系统；</span><br/>
		<span class="font_bold font_md">(c)遵守所有与网络服务有关的网络协议、规定和程序；</span><br/>
		<span class="font_bold font_md">(d)不得利用《高考早知道》服务系统进行任何可能对互联网的正常运转造成不利影响的行为；</span><br/>
		<span class="font_bold font_md">(e)不得利用《高考早知道》服务系统传输任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；</span><br/>
		<span class="font_bold font_md">(f)不得利用《高考早知道》服务系统进行任何不利于早知道大数据科技的行为。</span><br/>
		<span class="font_bold font_base">3、</span>未经授权收集、复制、使用、传播、出租、租借、交易、销售及承诺销售《高考早知道》产品和服务上的内容、信息或数据，《高考早知道》可追究其法律责任。<br/>
		<span class="font_bold font_base">4、</span>禁止任何通过逆向工程、反编译、反汇编、破译或试图得出《高考早知道》产品及服务或任何相关技术的源码的全部或任何部分。<br/>
		<span class="font_bold font_base">5、</span>禁止使用人工或自动软件、设备、脚本机器人程序、其他方式或程序访问、“抓取”、“爬取”或“挖掘”《高考早知道》产品及服务或其他相关数据或信息。<br/>
		<span class="font_bold font_base">6、</span>用户一旦注册成功，便成为《高考早知道》的用户，将得到一个帐号（手机号登录或者微信登录）。用户有义务采取合理措施维护其帐号的安全。 用户对利用该帐号所进行的一切活动负全部责任；由该等活动所导致的任何损失或损害均由用户承担责任。<br/>
		
		<span class="font_bold font_lg">四、《高考早知道》声明</span><br/>
		<span class="font_bold font_base">1、</span>《高考早知道》所展示、公布、使用的数据均来源于各省教育考试院和高校官方公布的信息，提供的信息仅供您参考，请以各高校 或各省教育考试院 正式公布数据为准。如果您发现系统中的任何错误，欢迎通过《高考早知道》中的“客服”进行反馈，《高考早知道》会 在核实后 第一时间 更正 。<br/>
		<span class="font_bold font_base">2、</span>《高考早知道》不保证所推荐的志愿填报 方案 必然能够导致用户得到录取，对用户或计算结果提供的资料、数据及内容也不作其他任何形式的担保， 不论是明确的或隐含的，包括所有有关信息真实性、适当性、适于某一特定用途、所有权和非侵权性的默示担保和条件，亦不保证《高考早知道》产品和服务不受阻挠或不出错误、不保证错误一定能得到纠正，对任何因用户不正当或非法使用服务产生的直接、间接、偶然、特殊及后续的损害，亦不承担任何责任。<br/>
		<span class="font_bold font_base">3、</span>《高考早知道》所提供的VIP会员服务中：<br/>
		<span class="font_bold font_md">1）{{wuchaName}}有效期为用户开通VIP服务成功之日起至开通后360天，{{wuchaName}}服务有效期截止时，所有{{wuchaName}}相关权限将无法享用（查大学、查升学、查试卷、查数据、查专业等）</span><br/>
		<span class="font_bold font_md">2）填报会员有效期为用户开通VIP服务成功之日起至购买后的下一个9月1日止（例：2021年8月购买，有效期至2021年9月1日；2021年9月2日购买，有效期至2022年9月1日），VIP会员服务有效期截止时，所有VIP相关权限将无法享用（包括“智能填报、一键填报、招生计划、历年专业分数线等”）</span><br/>
		<span class="font_bold font_base">4、</span>使用《高考早知道》产品及服务必须遵守国家有关法律和政策等，维护国家利益，保护国家安全，并遵守本条款，对于用户违法或违反本协议的使用(包括但不限于言论发表、传送等)而引起的一切责任，由用户负全部责任。<br/>
		<span class="font_bold font_base">5、</span>《高考早知道》产品及服务同大多数互联网产品一样，易受到各种安全问题的困扰，包括但不限于：<br/>
		<span class="font_bold font_md">1）透露详细个人资料，被不法分子利用，造成现实生活中的骚扰。</span><br/>
		<span class="font_bold font_md">2）哄骗、破译密码。</span><br/>
		<span class="font_bold font_md">3）下载安装的其它软件中含有“特洛伊木马”等病毒，威胁到个人计算机上信息和数据的安全，继而威胁对本服务的使用。</span><br/>
		<span class="font_bold font_md">对于发生上述情况的，用户应当自行承担责任。</span><br/>
		<span class="font_bold font_base">6、</span>《高考早知道》为了服务整体运营的需要，有权在公告通知后修改或中断、中止或终止服务，而无须向第三方负责或承担任何赔偿责任。<br/>
		<span class="font_bold font_base">7、</span>《高考早知道》亦有权根据本协议及相关法律规定对用户账户进行管理，包括但不限于隐藏、删除用户上载的内容、暂时或永久地关闭账户等，同时保留依法追究当事人法律责任的权利。<br/>
		<span class="font_bold font_base">8、</span>因互联网技术的不稳定性，可能导致政府政策管制、病毒入侵、黑客攻击、服务器系统崩溃或者其它现今技术无法解决的风险发生可能导致《高考早知道》产品及服务中断或帐号损失，《高考早知道》无需就此向用户负责或承担任何赔偿责任。<br/>
		
		<span class="font_bold font_lg">五、其他</span><br/>
		<span class="font_bold font_base">1、</span>用户确认已完全明了上述条款，自愿承担各自的义务与责任。<br/>
		<span class="font_bold font_base">2、</span>本协议受中华人民共和国法律管辖。如本协议任何条款与任何强制性法律有冲突，该条款服从法律的规定。<br/>
		<span class="font_bold font_base">3、</span>因履行本协议产生的争议，各方应友好协商解决。协商不成的，任何一方均应当向早知道大数据科技所在地有管辖权的人民法院提起诉讼。<br/>
		<span class="font_bold font_base">4、</span>点击页面的"同意"按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。<br/>
		<br/>
    </div>
    <div class='' v-else>
		<div class="font_bold font_lg">更新日期：2021年4月7日</div>
		<div class="font_bold font_lg">生效日期：2021年4月7日</div>
		<span class="font_bold font_base">高考早知道是一款由我们提供高考信息规划服务的产品，为说明高考早知道会如何收集、使用和存储你的个人信息及你享有何种权利，我们将通过本指引向你阐述相关事宜，其中要点如下：</span><br/>
		<span class="font_bold font_base">i.</span> 我们将逐一说明我们收集的你的个人信息类型及其对应的用途，以便你了解我们针对某一特定功能所收集的具体个人信息的类别、使用理由及收集方式。 <br/>
		<span class="font_bold font_base">ii.</span> 当你使用一些功能时，我们会在获得你的同意后，收集你的一些敏感信息，例如你你在使用拍摄功能时我们会收集你的手机图片信息，除非按照相关法律法规要求必须收集，拒绝提供这些信息仅会使你无法使用相关特定功能，但不影响你正常使用高考早知道的其他功能。 <br/>
		<span class="font_bold font_base">iii.</span> 目前，高考早知道不会主动共享或转让你的个人信息至第三方，如存在其他共享或转让你的个人信息或你需要我们将你的个人信息共享或转让至第三方情形时，我们会直接或确认第三方征得你对上述行为的明示同意，此外，我们会对对外提供信息的行为进行风险评估。<br/> 
		<span class="font_bold font_base">iv.</span> 目前，高考早知道不会主动从第三方获取你的个人信息。如未来为业务发展需要从第三方间接获取你的个人信息，我们会在获取前向你明示你个人信息的来源、类型及使用范围，如高考早知道开展业务需进行的个人信息处理活动超出你原本向第三方提供个人信息时的授权同意范围，我们将在处理你的该等个人信息前，征得你的明示同意；此外，我们也将会严格遵守相关法律法规的规定，并要求第三方保障其提供的信息的合法性。<br/>
		<span class="font_bold font_base">v.</span> 你可以通过本指引所列途径访问、更正、删除你的个人信息，也可以撤回同意、注销帐号、投诉举报以及设置隐私功能。<br/>
		<span class="font_bold font_base">vi.</span> 高考早知道的产品基于DCloud uni-app(5+ App/Wap2App)开发，应用运行期间需要收集你的设备唯一识别码（IMEI/android ID/DEVICE_ID/IDFA、SIM 卡 IMSI 信息、MAC地址）以提供统计分析服务，并通过应用启动数据及异常错误日志分析改进性能和用户体验，为用户提供更好的服务。<br/> 
		<span class="font_bold font_base">如你想了解更加详尽的信息，请根据以下索引阅读相应章节： </span><br/>
		<span class="font_bold font_base">1.</span> 我们收集的信息<br/>
		<span class="font_bold font_base">2.</span> 信息的存储<br/>
		<span class="font_bold font_base">3.</span> 信息安全<br/>
		<span class="font_bold font_base">4.</span> 我们如何使用信息<br/>
		<span class="font_bold font_base">5.</span> 对外提供<br/>
		<span class="font_bold font_base">6.</span> 你的权利<br/>
		<span class="font_bold font_base">7.</span> 变更<br/>
		<span class="font_bold font_base">8.</span> 联系我们<br/>
		<span class="font_bold font_lg">1.我们收集的信息</span><br/>
		在你使用高考早知道服务的过程中，高考早知道会按照如下方式收集你在使用服务时主动提供或因为使用服务而产生的信息，用以向你提供服务、优化我们的服务以及保障你的帐号安全： <br/>
		<span class="font_bold font_base">1.1</span> 当你注册高考早知道时，我们会收集你的昵称、头像、手机号码、性别、所在省市，收集这些信息是为了帮助你完成高考早知道注册，保护你高考早知道帐号的安全。手机号码属于敏感信息，收集此类信息是为了满足相关法律法规的网络实名制要求。若你不提供这类信息，你可能无法正常使用我们的服务。你还可以根据自身需求选择填写性别、地区等信息。<br/>
		<span class="font_bold font_base">1.2</span> 当你使用微信服务时，为保障你正常使用我们的服务，维护我们服务的正常运行，改进及优化我们的服务体验以及保障你的帐号安全，我们会收集你的设备型号、操作系统、唯一设备标识符、登陆IP地址、微信软件版本号、接入网络的方式、类型和状态、网络质量数据、设备加速器（如重力感应设备）、操作日志、服务日志信息（如你在微信搜索、查看的信息、服务故障信息、引荐网址等信息）等日志信息，这类信息是为提供服务必须收集的基础信息。<br/>
		<span class="font_bold font_base">1.3</span> 当你使用微信朋友圈功能时，你上传的朋友圈照片、评论、点赞等信息会存储在我们的服务器中，因为存储是实现这一功能所必需的。我们会以加密的方式存储，你也可以随时删除这些信息。除非经你自主选择或遵从相关法律法规要求，我们不会对外提供上述朋友圈信息，或者将其用于该功能以外的其他用途。<br/>
		<span class="font_bold font_base">1.4</span> 当你使用高考早知道课堂功能时，我们会收集你的搜索课程记录、学习记录和访问时间，目的是为了向你提供更加精准和个性化的服务和内容。 <br/>
		<span class="font_bold font_base">1.5</span> 当你使用高考早知道400客服电话时语音输入、语音与文字间转换时，我们会收集你的语音内容、待转换的语音文本信息，因为收集是实现上述功能所必需的。我们客服实时处理之后，向你返回处理结果，不会保存你的数据。 <br/>
		<span class="font_bold font_base">1.6</span> 高考早知道支付功能由财付通公司或支付宝公司向你提供服务。当你开通高考早知道支付功能时，财付通或支付宝公司会收集你的姓名、银行卡类型及卡号、有效期及银行预留手机号；当你使用高考早知道支付时，财付通或支付宝公司还会收集你的相关支付记录以便于你查询。上述信息属于敏感信息，拒绝提供该信息仅会使你无法使用高考早知道支付功能，但不影响你正常使用高考早知道的其他功能。<br/>
		另外，根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用你的相关个人信息无需征求你的授权同意： <br/>
		<span class="font_bold font_base">1)</span> 与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公众知情等重大公共利益直接相关的；<br/>
		<span class="font_bold font_base">2)</span> 与犯罪侦查、起诉、审判和判决执行等直接相关的；<br/>
		<span class="font_bold font_base">3)</span> 出于维护你或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；<br/>
		<span class="font_bold font_base">4)</span> 所收集的个人信息是你自行向社会公众公开的；<br/>
		<span class="font_bold font_base">5)</span> 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；<br/>
		<span class="font_bold font_base">6)</span> 根据你要求签订和履行合同所必需的； <br/>
		<span class="font_bold font_base">7)</span> 用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；<br/>
		<span class="font_bold font_base">8)</span>为开展合法的新闻报道所必需的；<br/>
		<span class="font_bold font_base">9)</span> 出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；<br/>
		<span class="font_bold font_base">10)</span> 法律法规规定的其他情形。<br/>
		请你理解，我们向你提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了你的信息，我们会通过页面提示、交互流程、网站公告等方式另行向你说明信息收集的内容、范围和目的，以征得你的同意。<br/> 
		请你注意，目前高考早知道不会主动从第三方获取你的个人信息。如未来为业务发展需要从第三方间接获取你个人信息，我们会在获取前向你明示你个人信息的来源、类型及使用范围，如高考早知道开展业务需进行的个人信息处理活动超出你原本向第三方提供个人信息时的授权同意范围，我们将在处理你的该等个人信息前，征得你的明示同意；此外，我们也将会严格遵守相关法律法规的规定，并要求第三方保障其提供的信息的合法性。 <br/>
		<span class="font_bold font_lg">2.信息的存储</span><br/>
		<span class="font_bold font_base">2.1</span> 信息存储的地点<br/>
		我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内。<br/>
		<span class="font_bold font_base">2.2</span> 信息存储的期限<br/>
		一般而言，我们仅为实现目的所必需的时间保留你的个人信息，例如：<br/>
		手机号码：若你需要使用高考早知道服务，我们需要一直保存你的手机号码，以保证你正常使用该服务，当你注销高考早知道帐户后，我们将删除相应的信息；<br/>
		当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。<br/>
		<span class="font_bold font_lg">3.信息安全</span><br/>
		我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露。<br/>
		我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们会使用加密技术（例如，SSL）、匿名化处理等手段来保护你的个人信息。 <br/>
		我们通过不断提升的技术手段加强安装在你设备端的软件的安全能力，以防止你的个人信息泄露。例如，我们为了安全传输会在你设备本地完成部分信息加密的工作；为了预防病毒、木马程序或其他恶意程序、网站会了解你设备安装的应用信息或正在运行的进程信息。 <br/>
		我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。<br/>
		若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知你。<br/>
		目前，高考早知道通过了国家网络安全等级保护（三级）的测评和备案，并已获得了相应的认证。 <br/>
		<span class="font_bold font_lg">4.我们如何使用信息</span><br/>
		我们可能将通过某些功能所收集的信息用于我们的其他服务。例如，我们可能将你在使用我们某一功能或服务时我们收集的信息，在另一功能或服务中用于向你提供特定内容，包括但不限于展示广告、对你阅读过的内容进行信息安全类提示、基于特征标签进行间接人群画像并提供更加精准和个性化的服务和内容等。）、对你阅读过的内容进行信息安全类提示、基于特征标签进行间接人群画像并提供更加精准和个性化的服务和内容等。<br/>
		为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，你使用应用程序的频率、崩溃数据、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与你在应用程序中提供的任何个人身份信息相结合。 <br/>
		如我们使用你的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用你的个人信息前，再次向你告知并征得你的明示同意。<br/>
		<span class="font_bold font_lg">5.对外提供</span><br/>
		目前，我们不会主动共享或转让你的个人信息至任何第三方，如存在其他共享或转让你的个人信息或你需要我们将你的个人信息共享或转让至第三方情形时，我们会直接或确认第三方征得你对上述行为的明示同意。 <br/>
		我们不会对外公开披露其收集的个人信息，如必须公开披露时，我们会向你告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得你的明示同意。 <br/>
		随着我们业务的持续发展，我们有可能进行合并、收购、资产转让等交易，我们将告知你相关情形，按照法律法规及不低于本指引所要求的标准继续保护或要求新的控制者继续保护你的个人信息。 <br/>
		另外，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得个人信息主体的授权同意： <br/>
		<span class="font_bold font_base">1）</span> 与国家安全、国防安全直接相关的；<br/>
		<span class="font_bold font_base">2）</span> 与公共安全、公共卫生、重大公共利益直接相关的；<br/>
		<span class="font_bold font_base">3）</span> 与犯罪侦查、起诉、审判和判决执行等直接相关的；<br/>
		<span class="font_bold font_base">4）</span> 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br/>
		<span class="font_bold font_base">5）</span> 个人信息主体自行向社会公众公开的个人信息；<br/>
		<span class="font_bold font_base">6）</span> 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。<br/>
		<span class="font_bold font_lg">6.与授权合作伙伴共享</span><br/>
		消息推送服务供应商：由每日互动股份有限公司提供推送技术服务，我们可能会将您的设备平台、设备厂商、设备品牌、设备识别码等设备信息，应用列表信息、网络信息以及位置相关信息提供给每日互动股份有限公司，用于为您提供消息推送技术服务。我们在向您推送消息时，我们可能会授权每日互动股份有限公司进行链路调节，相互促活被关闭的SDK推送进程，保障您可以及时接收到我们向您推送的消息。详细内容请访问《个推用户隐私政策》。<br/>
		<span class="font_bold font_lg">7.你的权利</span><br/>
		在你使用高考早知道期间，为了你可以更加便捷地访问、更正、删除你的个人信息，同时保障你撤回对个人信息使用的同意及注销帐号的权利，我们在产品设计中为你提供了相应的操作设置，你可以参考下面的指引进行操作。此外，我们还设置了投诉举报渠道，你的意见将会得到及时的处理。<br/>
		<span class="font_bold font_base">7.1</span> 访问个人信息<br/>
		<span class="font_bold font_base">7.1.1</span>访问头像、高考信息、考生信息、账号信息等基本信息：<br/>
		<span class="font_bold font_base">1)</span>  进入高考早知道后，点击“我的”；<br/>
		<span class="font_bold font_base">2)</span>  点击头像栏；<br/>
		<span class="font_bold font_base">3)</span>  进行信息查询访问。<br/>
		<span class="font_bold font_base">7.1.2</span>访问我的消息：<br/>
		<span class="font_bold font_base">1)</span>  进入高考早知道后，点击“我的”；<br/>
		<span class="font_bold font_base">2)</span>  点击界面右上角消息图标； <br/>
		<span class="font_bold font_base">3)</span>  进行系统通知、资讯推送、测评推送、社区消息的查询访问；<br/>
		<span class="font_bold font_base">7.2</span>更正个人信息<br/>
		<span class="font_bold font_base">7.2.1</span> 更改头像、昵称、性别、地区：<br/>
		<span class="font_bold font_base">1)</span>  进入高考早知道后，点击“我”；<br/>
		<span class="font_bold font_base">2)</span>  点击头像栏；<br/>
		<span class="font_bold font_base">3)</span>  更改头像、昵称、性别、地区。<br/>
		<span class="font_bold font_base">7.2.2</span> 更改高考早知道密码：<br/>
		<span class="font_bold font_base">1)</span> 进入高考早知道后，点击“我”； <br/>
		<span class="font_bold font_base">2)</span>  点击“设置”；<br/>
		<span class="font_bold font_base">3)</span>  点击“帐号与安全”；<br/>
		<span class="font_bold font_base">4)</span>  更改高考早知道密码。 <br/>
		<span class="font_bold font_base">7.3</span>注销帐号<br/>
		<span class="font_bold font_base">7.3.1</span>注销高考早知道帐号 <br/>
		<span class="font_bold font_base">1)</span> 进入高考早知道后，点击“我”；<br/> 
		<span class="font_bold font_base">2)</span> 点击“设置”；<br/>
		<span class="font_bold font_base">3)</span> 点击“帐号与安全”； <br/>
		<span class="font_bold font_base">4)</span> 点击“注销帐号” <br/>
		注： 当你注销帐号后，我们将删除或匿名化处理你的个人信息<br/>
		<span class="font_bold font_base">7.4</span> 投诉举报<br/>
		<span class="font_bold font_base">1)</span>  进入高考早知道后，点击“我的”； <br/>
		<span class="font_bold font_base">2)</span>  点击“设置”；<br/>
		<span class="font_bold font_base">3)</span>  点击“帐号与安全”； <br/>
		<span class="font_bold font_base">4)</span>  点击“投诉”；<br/>
		<span class="font_bold font_lg">8.变更</span><br/>
		我们可能会适时对本指引进行修订。当指引的条款发生变更时，我们会在你登录及版本更新时以推送通知、弹窗的形式向你展示变更后的指引。请你注意，只有在你点击弹窗中的同意按钮后，我们才会按照更新后的指引收集、使用、存储你的个人信息。<br/>
		<span class="font_bold font_lg">9.与我们联系</span><br/>
		当你有其他的投诉、建议，个人信息相关问题时，请通过 留言与我们联系。你也可以将你的问题寄到如下地址： <br/>
		福建省福州市台江区茶亭街道广达路68号金源大广场东区30层3002室 数据及隐私保护中心（收）<br/>
		邮编：350004<br/>
		我们将尽快审核所涉问题，并在验证你的用户身份后的三十天内予以回复。<br/>
		早知道（福建）大数据科技有限公司 <br/>
    </div>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
   name:'agreement_policy',
   props: {
      type: Number
    },
   //import引入的组件需要注入到对象中才能使用
   components: {},
   data() {
       return {
         wuchaName: '五查会员'
       };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {},
   //方法集合
   methods: {
       
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
       
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {
       
   },
   beforeCreate() {}, //生命周期 - 创建之前
   beforeMount() {}, //生命周期 - 挂载之前
   beforeUpdate() {}, //生命周期 - 更新之前
   updated() {}, //生命周期 - 更新之后
   beforeDestroy() {}, //生命周期 - 销毁之前
   destroyed() {}, //生命周期 - 销毁完成
   activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped lang='less'>
/* @import url(); 引入公共css类 */
.popup-box {
    height: 72vh;
    overflow-y: scroll;
}

.font_bold {
    font-weight: bold;
}

.font_lg {
	font-size: 16px;
}

.font_base {
    font-size: 15px;
}

span,div {
    line-height: 1.8;
}
</style>